"use client";
import { useTranslations } from "next-intl";
import { Icon } from "../../base/Icon/Icon";
import { cn } from "../../utils/classNames";
type Props = {
	className?: string;
};

const handleScrollToTop = () => {
	window.scrollTo({
		top: 0,
		behavior: "smooth",
	});
};

export const ScrollToTop = ({ className }: Props) => {
	const t = useTranslations("ScrollToTop");

	return (
		<button
			className={cn(
				"flex h-14 w-14 items-center justify-center rounded-full border-blue-500 bg-blue-500",
				className,
			)}
			onClick={handleScrollToTop}
			aria-label={t("accessibilityScrollToTop")}
		>
			<Icon icon="arrow-up" className="bg-white" />
		</button>
	);
};
